$(document).ready(function () {

    $('.works_cards_item_info.show_block').each(function () {
        const text = $(this).find('p').text();
        let new_strung = "";
        let start_srting = "";
        if (text.length > 200) {
            $(this).find('p').after('<span class="text_after"></span>')
        }
        for (let i = 0; i < text.length; i++) {
            if (i >= 200) {
                new_strung += text[i];
            } else {
                start_srting += text[i];
            }
        }
        $(this).find('p').empty().text(start_srting);
        $(this).find('.text_after').empty().text(new_strung)
    });

    $(document).on('click', '.js__view_text', function () {
        $(this).closest('.show_block').find('.text_after').toggle();
        $(this).closest('.show_block').find('.text_dots').toggle();
        $(this).find('.js__show_text').toggle()
        $(this).find('.js__hide_text').toggle()

        heaghtBlock();
    });

    $(".works_cards_wrap").find('.works_cards_item').each(function (index) {
        if (index > 0) {
            $(this).clone().appendTo('.works_cards_wrap_right')
            $(this).remove()
        }
    });

    heaghtBlock();

    $('.lang_chosen').click(function () {
        $('.lang_chose').slideToggle()
        $('.lang_arrow svg').toggleClass('rotate')
    })

    $(window).on('scroll', function () {
        var scroll = $(window).scrollTop();
        if (scroll < 1) {
            $(".header").removeClass("scroll");
        } else {
            $(".header").addClass("scroll");
        }
    });

    $('.second_level_footer').each(function (index) {
        let $findListSecondLi = $(this).find('li');
        if ($findListSecondLi.length > 5) {
            let $div = $('<ul class="second_level_footer second_level_secondary"></ul>');
            $findListSecondLi.filter(function (i) {
                return i > 4;
            }).appendTo($div);
            $div.insertAfter($(this));
        }
    });

    $('.second_level_secondary').each(function (index) {
        let $findListSecondLi = $(this).find('li');
        if ($findListSecondLi.length > 4) {
            let $div = $('<ul class="second_level_footer"></ul>');
            $findListSecondLi.filter(function (i) {
                return i > 3;
            }).appendTo($div);
            $div.insertAfter($(this));
        }
    });

    if ($('.main_slider_wrapper, .about_banner').length == 0) {
        let heighHeader = $('.js__header_up').outerHeight()
        $('.main-wrap').css('padding-top', `${heighHeader}px`)
    }

    $(document).on('click', '.open_modal_service', function () {
        $(this).next().toggle()
        $('.hidden_content_bg').toggle()
    });


    $(document).on('click', '.modal_exit', function () {
        $('.services_card_item_wrap .modal').hide()
        $('.hidden_content_bg').hide()
    });
    $(document).on('click', '.hidden_content_bg', function () {
        $('.services_card_item_wrap .modal').hide()
        $(this).hide()
    });


    $(document).on('click', '.slider_btn .js__anker', function () {
        const name = $(this).attr('data-anker');

        $('html, body').animate({
            scrollTop: $(`section[data-scroll="${name}"]`).offset().top - 100
        }, 800);
    });

    $('.js__drop').keyup(function () {
        $('.lang_list_select').show();
        const name = $(this).attr('data-type_search');
        $(this).closest('.search').addClass('active');
        var filter = $(this).val().trim();
        $('.lang_list_select button').each(function () {
            if ($(this).text().search(new RegExp(filter, "i")) < 0) {
                $(this).hide();
            } else {
                $(this).show()
            }
        });

        if (filter == "") {
            if (name == 'language') {
                $('.lang_list_select').hide();
                $('.js_search_block').removeClass('active');
                $('.js__hide_search_block').removeClass('hide');
                $(this).closest('.search').removeClass('active');
            } else {
                $('.vacancies_colum').show();
                $('.lang_list_select').hide();
            }

            $('.search').removeClass('active');
        }
    });

    $(document).on('click', '.js__reset', function () {
        $('.js_search_block').removeClass('active');
        $('.js__hide_search_block').removeClass('hide');
        $('.search').removeClass('active');
        $('.lang_list_select').hide();
        $('.top.lang_list.js__hide_search_block').show();
        $('.js__drop').val('');
        $('.js_reset_list').show()
    })

    $(document).mouseup(function (e) {
        var container = $(".lang_list_select");
        if (container.has(e.target).length === 0) {
            container.hide()
        }
    });

    $('.lang_list_select_chose button').click(function () {
        $('.lang_list_select').hide();
        $('.search').removeClass('active');
        const name = $(this).closest('.search').find('.js__drop').attr('data-type_search');

        const id = $(this).attr('data-id');
        if (name == 'language') {
            $('.lang_item').each(function (i) {
                if ($(this).attr('data-id') == id) {
                    $('.js_search_block').addClass('active');
                    $('.js_search_block .lang_list_item').empty();
                    $(this).clone().appendTo('.js_search_block .lang_list_item');
                    $('.js__hide_search_block').addClass('hide');
                }
            })
        } else {
            $('.vacancies_colum').hide();
            $('.vacancies_colum').each(function (i) {
                if ($(this).attr('data-id') == id) {
                    $(this).show();
                }
            })
        }
    });

    $(document).on('click', '.js__anker_button', function () {
        const name = $(this).attr('data-anker')

        $('html, body').animate({
            scrollTop: $(`#${name}`).offset().top - 100
        }, 800);
    });

    $(document).on('click', '.litter_filter_item button', function () {
        const litter = $(this).attr('data-litter');
        $('.top.lang_list.js__hide_search_block').hide();

        $('.bottom_lang_list .lang_list').each(function () {
            if ($(this).attr('data-tab') == litter) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });


    $(window).scroll(function () {
        if ($(this).scrollTop() != 0)
            $('.main_arrow_top').fadeIn();
        else
            $('.main_arrow_top').fadeOut();
    });


    $('.main_arrow_top').click(function () {
        $('body,html').animate({
            scrollTop: 0
        }, 800);
    });
});

function heaghtBlock() {
    $('.works_cards_wrap').css('height', '');
    if ($(window).width() >= 920) {
        let outerHeightRight = $('.works_cards_wrap_right').outerHeight()
        $('.works_cards_wrap').outerHeight(outerHeightRight)
    }
}

function alignmentTileNews() {
    $('.js__news_list .news_item_title').css('min-height', ``);

    let row_length = 1;
    if (window.innerWidth >= 768 && window.innerWidth <= 992) {
        row_length = 2
    } else if (window.innerWidth >= 993) {
        row_length = 3
    }

    $('.js__news_list').each(function () {
        let rows_title = {};
        let counter = 0;

        $(this).find('.news_item_title').each(function (i) {
            if (rows_title[counter]) {
                rows_title[counter] = [...rows_title[counter], $(this).outerHeight()];
            } else {
                rows_title[counter] = [$(this).outerHeight()];
            }

            if ((i + 1) % row_length === 0) {
                counter++;
            }
        })

        $(this).find('.news_item_title').each(function (i) {
            const row_number = Math.floor(i / row_length);
            const row_title = rows_title[row_number].sort((a, b) => {
                return a - b;
            }).reverse();

            $(this).css('min-height', `${row_title[0]}px`);
        })
    });
}

function alignmentTileService() {
    $('.js__service_list .services_card_name').css('min-height', ``);

    let row_length = 1;
    if (window.innerWidth >= 768 && window.innerWidth <= 992) {
        row_length = 2
    } else if (window.innerWidth >= 993) {
        row_length = 3
    }

    $('.js__service_list').each(function () {
        let rows_title = {};
        let counter = 0;

        $(this).find('.services_card_name').each(function (i) {
            if (rows_title[counter]) {
                rows_title[counter] = [...rows_title[counter], $(this).outerHeight()];
            } else {
                rows_title[counter] = [$(this).outerHeight()];
            }

            if ((i + 1) % row_length === 0) {
                counter++;
            }
        })

        $(this).find('.services_card_name').each(function (i) {
            const row_number = Math.floor(i / row_length);
            const row_title = rows_title[row_number].sort((a, b) => {
                return a - b;
            }).reverse();

            $(this).css('min-height', `${row_title[0]}px`);
        })
    });
}

$(window).resize(function () {
    heaghtBlock();
    alignmentTileNews();
    alignmentTileService();
})

$(window).on('load', function () {
    alignmentTileNews();
    alignmentTileService();
})



// WEBPACK FOOTER //
// ./resources/js/main.js